import ConfirmModal, { ConfirmModalHeader } from "PFComponents/confirm/confirm_modal";
import React from "react";
import { useTranslation } from "react-i18next";

import css from "./confirm_delete_modal.module.scss";

type ConfirmDeleteModalProps = {
  reportName: string;
  onDelete: VoidFunction;
  onClose: VoidFunction;
};

export const ConfirmDeleteModal = ({
  reportName,
  onClose,
  onDelete
}: ConfirmDeleteModalProps): JSX.Element => {
  const { t } = useTranslation(["bookingModule", "translation"]);

  return (
    <ConfirmModal
      labelOK={t("translation:delete")}
      handleOK={onDelete}
      handleClose={onClose}
      classes={{ modal: css.root }}
    >
      <ConfirmModalHeader>
        {t("bookingModule:reports.manageReports.reports.deleteReport.title")}
      </ConfirmModalHeader>
      <span>{t("bookingModule:reports.manageReports.reports.deleteReport.content", { reportName })}</span>
    </ConfirmModal>
  );
};
